import * as React from "react";
const SvgFiRrCommentMedical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-comment-medical_svg__a)">
      <path
        fill="#062147"
        d="M12.854.03a12.02 12.02 0 0 0-9.339 3.485 12.02 12.02 0 0 0-3.485 9.34C.47 19.207 6.095 24 13.113 24h5.888C21.944 24 24 21.596 24 18.153v-5.815C24 5.87 19.104.463 12.854.03M22 18.153C22 20.454 20.795 22 19.001 22h-5.888c-6.052 0-10.715-3.905-11.088-9.285A10.02 10.02 0 0 1 4.929 4.93a10.02 10.02 0 0 1 7.786-2.905C17.922 2.385 22 6.915 22 12.336v5.817M17 12a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-2 0v-3H8a1 1 0 0 1 0-2h3V8a1 1 0 0 1 2 0v3h3a1 1 0 0 1 1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-comment-medical_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCommentMedical;
